import { createSelector } from 'reselect';
import { RootState } from 'src/store';
import {
    buildSizeChartFromProduct,
    resolveBodyWidthMm,
    resolveBodyLengthMm,
} from 'src/pages/editor/components/decorationSpecs/productPropertySizeChart';
import { getProductDetails } from './getSurfaceProperties';

const getDecorationSpecsState = (state: RootState) => state.pages.editor.decorationSpecs;

export const getProductModel = createSelector([getDecorationSpecsState], (state) => state.productModel);

export const getSizeChart = createSelector([getProductModel, getProductDetails], (productModel, surfaceDetails) => {
    // Only derive size chart if a product is actually selected/added into the editor (isReady true)
    if (!surfaceDetails?.isReady) {
        return null;
    }
    return buildSizeChartFromProduct(productModel, surfaceDetails.merchantVariables ?? {});
});

export const getBodyMeasurements = createSelector(
    [getProductModel, getProductDetails],
    (productModel, surfaceDetails) => {
        if (!surfaceDetails?.isReady) {
            return {
                bodyWidthMm: undefined,
                bodyLengthMm: undefined,
            };
        }
        const selections = surfaceDetails.merchantVariables ?? {};
        const size = selections.Size ?? '';
        return {
            bodyWidthMm: resolveBodyWidthMm(productModel, selections, size),
            bodyLengthMm: resolveBodyLengthMm(productModel, selections, size),
        };
    },
);

const getDecorationSpecs = createSelector(
    [getDecorationSpecsState, getSizeChart, getBodyMeasurements],
    (decorationSpecsState, sizeChart, bodyMeasurements) => ({
        ...decorationSpecsState,
        sizeChart,
        bodyWidthMm: bodyMeasurements.bodyWidthMm,
        bodyLengthMm: bodyMeasurements.bodyLengthMm,
    }),
);

export default getDecorationSpecs;
